/* global modUtils */
export function getFormDataCookie() {
	return modUtils.getCookie('formData');
}
